<div class="layout_blank">
  <router-outlet></router-outlet>
</div>
